import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        yhmc: null, // 用户名称
        zsxm: null, // 真实姓名
        qgdm: null, // 监管部门
        yhlbs: null, // 用户类别
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "用户名称：",
          value: "yhmc",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "真实姓名：",
          value: "zsxm",
          placeholder: "请输入",
          clearable: true
        },
         {
          label: "监管部门：",
          type: "select",
          value: "qgdm",
          placeholder: "请输入",
          queryParams: {
            url: "/zoneDepartment/DepartmentCombobox",
          },
        },
        {
          label: "用户类别：",
          type: "select",
          value: "yhlb",
          placeholder: "请输入",
          optionData: [
            {
              name: "平台工作人员",
              value: "01"
            },
            {
              name: "招标监管",
              value: "02"
            },
          ],
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "用户名称",
          prop: "yhmc",
          isShow: true,
        },
        {
          label: "真实姓名",
          prop: "zsxm",
        },
        {
          label: "用户性别",
          prop: "yhxb",
        },      
        {
          label: "部门名称",
          prop: "bmmc",
        }, 
        {
          label: "角色",
          prop: "jsidmc",
        }, 
        
      ],
      // 表格数据
      tableData: [],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/spProcessNodeUser/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/spProcessNodeUserDetail",
        query: {
          id: e.val.id,
          type: "details"
        }
      });
    },
  }
};
